import {compact} from '@benchling/js-utils';

import {getLabelColumns} from 'bulk-import/getLabelColumns';
import {
  IMPORT_TYPE,
  RegistryImportSettingsProps,
  SelectedSchemaIds,
  SpreadsheetColumn,
} from 'bulk-import/SpreadsheetBulkImportConstants';
import * as SpreadsheetBulkImportUtil from 'bulk-import/SpreadsheetBulkImportUtil';
import * as TransferColumnsUtil from 'bulk-import/TransferColumnsUtil';
import {canSchemaHaveMods} from 'molbio/OligoUtil';

export default function getRegistryEntityRequiredColumnsError(
  columns: Array<SpreadsheetColumn>,
  {
    selectedSchemaIds,
    registryImportSettings,
    importType,
  }: {
    selectedSchemaIds: SelectedSchemaIds;
    registryImportSettings: RegistryImportSettingsProps;
    importType: IMPORT_TYPE;
  }
): null | string {
  const basesModsColumnsError = SpreadsheetBulkImportUtil.getErrorForCreatingPolymer(
    columns,
    SpreadsheetBulkImportUtil.shouldHaveResidues(selectedSchemaIds),
    canSchemaHaveMods(SpreadsheetBulkImportUtil.getTagSchema(selectedSchemaIds)!)
  );
  if (basesModsColumnsError) {
    return basesModsColumnsError;
  }

  const measurementColumnsError = TransferColumnsUtil.getMeasurementColumnsError(columns, false);
  if (measurementColumnsError) {
    return measurementColumnsError;
  }

  const chemicalStructureError = SpreadsheetBulkImportUtil.getErrorForChemicalStructureColumns(
    columns,
    SpreadsheetBulkImportUtil.shouldHaveChemicalStructure(selectedSchemaIds),
    true
  );
  if (chemicalStructureError) {
    return chemicalStructureError;
  }

  const requiredLabelColumns = compact(getLabelColumns(registryImportSettings));
  return SpreadsheetBulkImportUtil.getRequiredFieldError(
    requiredLabelColumns,
    columns,
    selectedSchemaIds,
    importType
  );
}
